import { applyMiddleware, createStore, compose } from 'redux';
import { rootReducer } from './reducers';
import { middlewares } from './middlewares';
import { StoreState } from '../types/ReduxMisc';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const configureStore = (initialState?: Partial<StoreState>) =>
  createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );
